import React, { useState } from 'react';
import { Form, Dropdown, Badge, Button } from 'react-bootstrap';
import { X } from 'lucide-react';

const MultiSearchSelect = ({ 
    options = [], 
    value = [], 
    onChange, 
    placeholder = "Buscar y añadir...", 
    disabled = false,
    labelField = "full_name" // o "name" o "plate"
}) => {
    const [search, setSearch] = useState('');
    
    const safeOptions = Array.isArray(options) ? options.filter(o => o !== null) : [];
    const selectedIds = Array.isArray(value) ? value.map(id => String(id)) : [];
    
    // Obtenemos los objetos completos de los seleccionados para mostrar las etiquetas
    const selectedItems = safeOptions.filter(o => selectedIds.includes(String(o.id)));
    
    const getLabel = (item) => {
        if (item.internal_code) return `[${item.internal_code}] ${item.full_name || item.name || item.plate}`;
        return item.full_name || item.name || item.plate || "S/N";
    };

    const handleToggle = (id) => {
        const idStr = String(id);
        let newValue;
        if (selectedIds.includes(idStr)) {
            newValue = selectedIds.filter(val => val !== idStr);
        } else {
            newValue = [...selectedIds, idStr];
        }
        onChange(newValue.map(Number));
    };

    const filteredOptions = safeOptions.filter(o => {
        const searchText = search.toLowerCase();
        const textToSearch = `${o.full_name || ''} ${o.name || ''} ${o.rut || ''} ${o.internal_code || ''} ${o.plate || ''}`.toLowerCase();
        return textToSearch.includes(searchText);
    });

    return (
        <div className="multi-search-select border rounded p-2 bg-white shadow-sm" style={{ minHeight: '38px' }}>
            <div className="d-flex justify-content-between align-items-start mb-2">
                <div className="d-flex flex-wrap gap-1 flex-grow-1">
                    {selectedItems.map(item => (
                        <Badge 
                            key={item.id} 
                            bg="primary" 
                            className="d-flex align-items-center gap-1 py-1 px-2"
                            style={{ fontSize: '0.85em', fontWeight: 'normal' }}
                        >
                            {getLabel(item)}
                            {!disabled && (
                                <X 
                                    size={14} 
                                    className="cursor-pointer hover-opacity" 
                                    onClick={() => handleToggle(item.id)} 
                                />
                            )}
                        </Badge>
                    ))}
                    {selectedItems.length === 0 && <span className="text-muted small my-1 ms-1">{placeholder}</span>}
                </div>
                {selectedIds.length > 0 && !disabled && (
                    <Button 
                        variant="link" 
                        size="sm" 
                        className="text-danger p-0 ms-2 text-decoration-none" 
                        onClick={() => onChange([])}
                        style={{ fontSize: '0.75rem' }}
                    >
                        Limpiar todo
                    </Button>
                )}
            </div>

            {!disabled && (
                <Dropdown className="w-100" autoClose="outside">
                    <Dropdown.Toggle 
                        as="div" 
                        className="p-0 border-0 bg-transparent w-100" 
                        style={{ cursor: 'pointer' }}
                    >
                        <Form.Control 
                            size="sm" 
                            placeholder="🔍 Escribe para buscar..." 
                            value={search} 
                            onChange={(e) => setSearch(e.target.value)} 
                            className="border-0 bg-light"
                        />
                    </Dropdown.Toggle>
                    
                    <Dropdown.Menu 
                        className="w-100 shadow" 
                        style={{ maxHeight: '250px', overflowY: 'auto' }}
                    >
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map(opt => (
                                <Dropdown.Item 
                                    key={opt.id} 
                                    onClick={() => handleToggle(opt.id)}
                                    active={selectedIds.includes(String(opt.id))}
                                >
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span>
                                            {opt.internal_code && <strong className="me-2">[{opt.internal_code}]</strong>}
                                            {opt.full_name || opt.name || opt.plate}
                                        </span>
                                        {selectedIds.includes(String(opt.id)) && <Badge bg="success">✓</Badge>}
                                    </div>
                                </Dropdown.Item>
                            ))
                        ) : (
                            <div className="p-2 text-center text-muted small">No hay resultados</div>
                        )}
                    </Dropdown.Menu>
                </Dropdown>
            )}
        </div>
    );
};

export default MultiSearchSelect;
